import { Assert } from '@cotera/utilities';
import { createContext, useContext } from 'react';
import { ExpressionColumnModel } from './expression-column.model';

export const ColumnModelContext = createContext<ExpressionColumnModel | null>(
  null
);

export const useColumnModel = () => {
  const model = useContext(ColumnModelContext);
  Assert.assert(model !== null, 'Column model not found');
  return model;
};
